module.exports = __webpack_public_path__ + "static/media/5.fd27ea22.JPG";